import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { BREADCRUMBS } from 'config';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { Router } from '@angular/router';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss'],
})

export class TermsConditionsComponent implements OnInit {

  tnc: string;
  constructor(private breadCrumbService: BreadCrumbService, private utilityService: UtilityService, private router: Router) { }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];

    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Sign-up', routerLink: '' });
    this.tnc = sessionStorage.getItem('termsAndConditionContent');
  }
}
